export default "__VITE_ASSET__BVoDhlzZ__"